import Vue from 'vue'
import VueRouter from 'vue-router'
// import Login from './Login.vue'
// import Testing from './testing.vue'
import Search from './Search.vue'
import MainList from './MainList.vue'
import ItemDetail from './ItemDetail.vue'
import ShoppCart from './ShoppCart.vue'
import EditItemDetail from './EditItemDetail.vue'
import PurchaseHistory from './PurchaseHistory.vue'
import viewOrder from './viewOrder.vue'

import BackendLogin from './BackLogin'
import BackendMain from './BackendMain'
import Register from './Register.vue'
import NotFound from './NotFound.vue'
import noLongerAvlb from './NoLongerAvlb.vue'
// import NotFound from './NotFound.vue'
import globalVar from './GlobalVar.js'

Vue.use(VueRouter)

var routesSet
if (globalVar.mode == 'normal') {
  routesSet = [
    {
      path: '',
      component: Search
    },
    {
      path: '/mainlist',
      component: MainList,
      meta: { authenticated: true }
    },
    {
      path: '/shopping-cart',
      component: ShoppCart,
      meta: { authenticated: true }
    },
    {
      path: '/PurchaseHistory',
      component: PurchaseHistory
    },
    {
      path: '/ViewOrder',
      component: Search,
      params: { token: '' }
    },
    {
      path: '/ViewOrder/:token',
      name: 'viewOrder',
      component: viewOrder,
      props: true
    },
    {
      path: '/ViewOrder/:token/**',
      component: Search,
      params: { token: '' }
    },
    {
      path: '/so',
      name: 'so',
      component: Search,
      params: { tableNumLink: '' }
    },
    {
      path: '/so/:tableNumLink',
      name: 'so',
      component: Search,
      props: true
    },
    {
      path: '/so/:tableNumLink/**',
      name: 'so',
      component: Search,
      params: { tableNumLink: '' }
    },
    {
      path: '/daccess',
      name: 'daccess',
      component: Search,
      params: { loginKey: '' }
    },
    {
      path: '/daccess/:loginKey',
      name: 'daccess',
      component: Search,
      props: true
    },
    {
      path: '/daccess/:loginKey/**',
      name: 'daccess',
      component: Search,
      params: { loginKey: '' }
    },
    {
      path: '/ItemDetail/:itemId',
      name: 'ItemDetail',
      component: ItemDetail,
      props: true,
      meta: { authenticated: true }
    },
    {
      path: '/ItemDetail',
      params: { itemId: '' },
      redirect: '/'
    },
    {
      path: '/EditItemDetail/:itemId',
      name: 'EditItemDetail',
      component: EditItemDetail,
      props: true,
      meta: { authenticated: true }
    },
    {
      path: '/EditItemDetail',
      params: { itemId: '' },
      redirect: '/'
    },
    {
      path: '/back',
      name: 'back',
      component: BackendLogin
    },
    {
      path: '/Backend',
      name: 'Backend',
      component: BackendMain,
      meta: { authenticated: true }
    },
    {
      path: '/table',
      params: { tblNum: '' },
      redirect: '/'
    },
    {
      path: '/table/:tblNum',
      name: 'table',
      component: Search,
      props: true
    },
    {
      path: '/table/:tblNum/**',
      name: 'table',
      component: Search,
      params: { tblNum: '' }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
} else if (globalVar.mode == 'lite') {
  routesSet = [
    {
      path: '',
      name: 'Register',
      component: Register
    },
    {
      path: '/ag',
      params: { agCode: '' },
      component: NotFound
    },
    {
      path: '/ag/:agCode', //Agent Code
      name: 'Register',
      component: Register,
      props: true
    },
    {
      path: '/:mchdCode',
      name: 'Search',
      component: Search,
      props: true
    },
    {
      path: '/:mchdCode/mainlist',
      component: MainList,
      name: 'MainList',
      meta: { authenticated: true }
    },
    {
      path: '/:mchdCode/shopping-cart',
      name: 'ShoppCart',
      component: ShoppCart,
      meta: { authenticated: true }
    },
    {
      path: '/:mchdCode/PurchaseHistory',
      name: 'PurchaseHistory',
      component: PurchaseHistory
    },
    {
      path: '/:mchdCode/ViewOrder',
      component: Search,
      name: 'Search',
      params: { token: '' }
    },
    {
      path: '/:mchdCode/ViewOrder/:token',
      name: 'viewOrder',
      component: viewOrder,
      props: true
    },
    {
      path: '/:mchdCode/ViewOrder/:token/**',
      component: Search,
      name: 'Search',
      params: { token: '' }
    },
    {
      path: '/:mchdCode/so',
      name: 'so',
      component: Search,
      params: { tableNumLink: '' }
    },
    {
      path: '/:mchdCode/so/:tableNumLink',
      name: 'so',
      component: Search,
      props: true
    },
    {
      path: '/:mchdCode/so/:tableNumLink/**',
      name: 'so',
      component: Search,
      params: { tableNumLink: '' }
    },

    {
      path: '/:mchdCode/daccess',
      name: 'daccess',
      component: Search,
      params: { loginKey: '' }
    },
    {
      path: '/:mchdCode/daccess/:loginKey',
      name: 'daccess',
      component: Search,
      props: true
    },
    {
      path: '/:mchdCode/daccess/:loginKey/**',
      name: 'daccess',
      component: Search,
      params: { loginKey: '' }
    },
    {
      path: '/:mchdCode/ItemDetail/:itemId',
      name: 'ItemDetail',
      component: ItemDetail,
      props: true,
      meta: { authenticated: true }
    },
    {
      path: '/:mchdCode/ItemDetail',
      params: { itemId: '' },
      component: NotFound
      // redirect: '/'
    },
    {
      path: '/:mchdCode/EditItemDetail/:itemId',
      name: 'EditItemDetail',
      component: EditItemDetail,
      props: true,
      meta: { authenticated: true }
    },
    {
      path: '/:mchdCode/EditItemDetail',
      params: { itemId: '' },
      component: NotFound
    },
    {
      path: '/:mchdCode/back',
      name: 'Back',
      component: BackendLogin,
      props: true
    },
    {
      path: '/:mchdCode/Backend',
      name: 'Backend',
      component: BackendMain,
      meta: { authenticated: true }
    },
    {
      path: '/:mchdCode/table',
      params: { tblNum: '' },
      component: NotFound
      // redirect: '/'
    },
    {
      path: '/:mchdCode/table/:tblNum',
      name: 'table',
      component: Search,
      props: true
    },
    {
      path: '/:mchdCode/table/:tblNum/**',
      name: 'table',
      component: Search,
      params: { tblNum: '' }
    },
    {
      path: '/:mchdCode/NotFound',
      name: 'NotFound',
      component: NotFound
      // redirect: '/'
    },
    {
      path: '/NotFound',
      name: 'NotFound',
      component: NotFound
      // redirect: '/'
    },
    {
      path: '/:mchdCode/NoAvailable',
      name: 'noLongerAvlb',
      component: noLongerAvlb
      // redirect: '/'
    },
    {
      path: '*',
      component: NotFound
      // redirect: '/'
    }
  ]
}

export default new VueRouter({
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  routes: routesSet
  // {
  //   path: '',
  //   component: Login
  // },
  // {
  //   path: '/register',
  //   component: Register
  // },{
  //   path: '/testing',
  //   component: Testing
  // },
})
